import React, { createContext, useContext, useState } from "react";

const SearchResultContext = createContext({
    result: null,
    isLoading: false,
    setLoading: () => {}
});

export const SearchResultProvider = ({ children }) => {
    const [result, setResult] = useState(null);

    const handleSetResult = async (newResult) => {
        try {
            setResult(newResult);
        } catch (error) {
            console.error(error);
        } finally {

        }
    };

    return (
        <SearchResultContext.Provider value={{ result, handleSetResult }}>
            {children}
        </SearchResultContext.Provider>
    );
};

function useSearch() {
    const context = useContext(SearchResultContext);

    if (context === undefined) {
        throw new Error("useSearch must be used within a SearchResultProvider");
    }

    return context;
}

export { SearchResultContext, useSearch };
